import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=70591360&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=70591360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70591360",
  null
  
)

export default component.exports